/* tslint:disable */
/* eslint-disable */
/**
 * app
 * app
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StateTown
 */
export interface StateTown {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    state_id?: string;
    /**
     * 
     */
    city?: string;
    /**
     * 
     */
    city_ascii?: string;
    /**
     * 
     */
    city_alternative?: string;
    /**
     * 
     */
    county_name?: string;
}

/**
 * Check if a given object implements the StateTown interface.
 */
export function instanceOfStateTown(value: object): value is StateTown {
    return true;
}

export function StateTownFromJSON(json: any): StateTown {
    return StateTownFromJSONTyped(json, false);
}

export function StateTownFromJSONTyped(json: any, ignoreDiscriminator: boolean): StateTown {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'state_id': json['state_id'] == null ? undefined : json['state_id'],
        'city': json['city'] == null ? undefined : json['city'],
        'city_ascii': json['city_ascii'] == null ? undefined : json['city_ascii'],
        'city_alternative': json['city_alternative'] == null ? undefined : json['city_alternative'],
        'county_name': json['county_name'] == null ? undefined : json['county_name'],
    };
}

export function StateTownToJSON(json: any): StateTown {
    return StateTownToJSONTyped(json, false);
}

export function StateTownToJSONTyped(value?: StateTown | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'state_id': value['state_id'],
        'city': value['city'],
        'city_ascii': value['city_ascii'],
        'city_alternative': value['city_alternative'],
        'county_name': value['county_name'],
    };
}

